// The session sheets, opened from a row's menu and drawn once by
// SessionSheetsHost (inside OverlayHost), so no pane mounts its own copies:
//   fork    ForkDialog (Duplicate)
//   report  ReportDialog (Report session)
//   invite  InviteDialog (W4 rebuilds it to the Invite boards)
import { reactive } from "vue";

export const SESSION_SHEETS = ["fork", "report", "invite"];

export const sessionSheetState = reactive({ kind: null, session: null, seq: 0 });

export function open(kind, session) {
  if (!SESSION_SHEETS.includes(kind) || !session || !session.name) return;
  sessionSheetState.kind = kind;
  sessionSheetState.session = session;
  sessionSheetState.seq += 1;
}

export function close() {
  sessionSheetState.kind = null;
}

export const sessionSheets = { open, close, state: sessionSheetState };
export default sessionSheets;
